import { Button } from "@dash/form";
import { SectionHeader } from "@dash/page";
import { useTheme } from "@emotion/react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import { useClientManager } from "@megaron/react-clients";
import { TicketsQueryQs } from "@megaron/support-contracts";
import { Uuid } from "@megaron/uuid";

import { CustomerSupportTicketsCards } from "./CustomerSupportTicketsCards";

type Props = {
  customerUuid: Uuid;
  defaultReporterEmail: string;
  defaultReporterFirstName: string;
  defaultReporterLastName: string;
  defaultReporterName: string;
};

export const CustomerSupportTicketsList: FC<Props> = ({
  customerUuid,
  defaultReporterEmail,
  defaultReporterFirstName,
  defaultReporterLastName,
  defaultReporterName,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const ticketsListQuery: TicketsQueryQs = {
    offset: 0,
    limit: 50,
    searchText: undefined,
    status: undefined,
    priority: undefined,
    category: undefined,
    tags: undefined,
    sort: "createdAt",
    sortOrder: "desc",
    myTickets: undefined,
    isRead: undefined,
    contactEmail: undefined,
    customerUuid: customerUuid,
  };

  const ticketsQuery = useClientManager("support").ticketsList().useQuery(ticketsListQuery);

  const onCreateTicket = () => {
    const params = new URLSearchParams({
      customerUuid: customerUuid.toString(),
      reporterEmail: defaultReporterEmail,
      reporterFirstName: defaultReporterFirstName,
      reporterLastName: defaultReporterLastName,
      reporterName: defaultReporterName,
    });
    navigate(`/crm/zgloszenia/nowe?${params.toString()}`);
  };

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <SectionHeader
        isHr
        css={{ marginTop: "0", h2: { color: theme.colors.primary } }}
        actions={
          <Button variant="outline" css={{ fontSize: "12px", padding: "4px 8px" }} onClick={onCreateTicket}>
            Dodaj
          </Button>
        }
      >
        Zgłoszenia
      </SectionHeader>
      <CustomerSupportTicketsCards ticketsQuery={ticketsQuery} />
    </div>
  );
};
